import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import ImageWithBasePath from "../../../../core/img/ImageWithBasePath";
import { all_routes } from "../../../../core/data/routes/all_routes";
import BreadCrumb from "../../common/breadcrumb/breadCrumb";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { addDoc, collection, doc, getDocs, setDoc } from "firebase/firestore";
import { auth, db } from "../../../../firebase";
import React from "react";
import axios from "axios";

const Booking1 = () => {
  const routes = all_routes;
  const [value, onChange] = useState(new Date());

  const city = [
    { name: "Select City" },
    { name: "Tornoto" },
    { name: "Texas" },
  ];
  const state = [
    { name: "Select State" },
    { name: "Tornoto" },
    { name: "Texas" },
  ];
  const country = [{ name: "Select Country" }, { name: "US" }, { name: "UK" }];

  //booking Fetch Data
  const location = useLocation();
  const navigate = useNavigate();
  const category = location.state?.category;
  const [count, setCount] = useState(0);
  const [selectedColor, setSelectedColor] = useState("#000000");

  if (!category) {
    return <p>Category data not found!</p>;
  }

  const handleBookAppointment = () => {
    console.log("Navigating to booking2");
    // navigate(routes.bookingPayment, { state: { category } });
    navigate(routes.bookingTech, { state: { category } });
  };

  function handleCheckboxChange(index: number, checked: boolean): void {
    throw new Error("Function not implemented.");
  }

  // Promo Code Fetch from Firebase
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [offers, setOffers] = useState([]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [selectedOffer, setSelectedOffer] = useState<string>("");
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [totalSaving, setTotalSaving] = useState<number | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-redeclare, react-hooks/rules-of-hooks
  const [userLocation, setUserLocation] = useState("");

  // Fetch offers from Firestore
  const fetchOffers = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "offers"));
      const offersList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(), // Ensure all fields, including `description`, are included
      }));
      setOffers(offersList);
    } catch (error) {
      console.error("Error fetching offers:", error);
    } finally {
    }
  };

  // Fetch data when component mounts
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    fetchOffers();
  }, []);

  // Handle applying the promo code
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [appliedPromoId, setAppliedPromoId] = useState<string | null>(null);

  const applyPromoCode = () => {
    if (selectedOffer) {
      const selectedOfferDetails = offers.find(
        (offer) => offer.id === selectedOffer
      );

      if (selectedOfferDetails) {
        setTotalSaving(selectedOfferDetails.discount); // Assuming `discount` field exists
        setAppliedPromoId(selectedOfferDetails.id); // Store promo ID to display
      }
    }
  };

  //Fetching Location --------
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    async function getLocation() {
      try {
        const response = await axios.get("https://ipapi.co/json/");
        setUserLocation(
          `${response.data.city}, ${response.data.region}, ${response.data.country_name}`
        );
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    }

    getLocation();
  }, []);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [selectedTime, setSelectedTime] = useState(null);
  const timeSlots = [ "08.00AM", "08.30AM", "09.00 AM","09.30 AM", "10.00 AM","10.30 AM","11.00 AM","11.30 AM","12.00 PM", "12.30 PM",
    "01.00 PM","01.30 PM", "02.00 PM","02.30 PM", "03.00 PM","03.30 PM","04.00 PM","04.30 PM","05.00 PM", "05.30 PM","06.00 PM","06.30 PM",
    "07.00 PM","07.30 PM","08.00 PM","08.30 PM","09.00 PM","09.30 PM",
  ];

    // Initialize state with a default value (e.g., 1 hour)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [selectedHours, setSelectedHours] = useState();

    // Handle change in the dropdown selection
    const handleChange = (e: { target: { value: React.SetStateAction<undefined>; }; }) => {
      setSelectedHours(e.target.value);
    };
  
    const timeOptions = [
      { value: '0.5', label: '30 minutes' },
      { value: '1', label: '1 hour' },
      { value: '1.5', label: '1.5 hours' },
      { value: '2', label: '2 hours' },
      { value: '2.5', label: '2.5 hours' },
      { value: '3', label: '3 hours' },
    ];

  const generateCustomId = (): string => {
    const mgPart = `MG${Math.floor(10000 + Math.random() * 90000)}`; // 5-digit random number
    const raPart = `RA${Math.floor(1000 + Math.random() * 9000)}`; // 4-digit random number
    return `${mgPart}${raPart}`;
  };

  const generateOrderNumber = (): number => {
    const timestampPart = Date.now().toString().slice(-10); // Last 10 digits of timestamp
    const randomPart = Math.floor(100000 + Math.random() * 900000); // 6-digit random number
    return parseInt(`${timestampPart}${randomPart.toString().slice(0, 5)}`); // Ensure 15 digits
  };

  //Create a FireBAse Start-----------
  const saveAppointment = async () => {
    if (!selectedTime || !value) {
      alert("Please select date and time");
      return;
    }
  
    try {
      const user = auth.currentUser;
      if (!user) {
        alert("User not authenticated.");
        return;
      }
  
      const clientName = user.displayName || "";
  
      // Generate timestamp-based document ID
      const now = new Date();
      const formattedTimestamp = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}_${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}_${now.getTime()}`;
  
      const requirements = category.fields.map((field: { lbl: string; type: string }) => {
        let fieldValue;
        const sanitizedLabel = field.lbl.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, ''); // Sanitize the label
  
        switch (field.type) {
          case "counter":
            fieldValue = count;
            break;
          case "select":
            fieldValue = selectedOffer || "";
            break;
          case "pickColor":
            fieldValue = selectedColor;
            break;
          case "input":
            fieldValue = document.querySelector(`#input-${sanitizedLabel}`)?.value || "";
            break;
          case "checkbox":
            fieldValue = document.querySelector(`#checkbox-${sanitizedLabel}`)?.checked || false;
            break;
          default:
            fieldValue = "";
        }
        return { lbl: field.lbl, value: fieldValue };
      });
  
      const appointmentData = {
        category: category,
        client_name: clientName,
        client_user_id: user.uid,
        datetime: value,
        id: formattedTimestamp, // Use generated timestamp as ID
        promoCode: appliedPromoId || "",
        requirements: requirements,
        starttime: selectedTime,
        workinghours: selectedHours || 0,
        type: category.main_type,
      };
  
      // Save to Firestore with custom document ID
      await setDoc(doc(db, "appointments_testing", formattedTimestamp), appointmentData);
  
      console.log("Appointment saved with ID: ", formattedTimestamp);
      alert("Appointment successfully booked!");
      navigate(routes.bookingTech, { state: { category } });
    } catch (error) {
      console.error("Error saving appointment: ", error);
    }
  };
  
  

  //Create a Firebase End------------

  return (
    <>
      <BreadCrumb title="Bookings" item1="Customer" item2="Appointment" />
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content"
          style={{
            backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}>
            <div className="container">
              <div className="row">
                {/* Booking */}
                <div className="col-lg-12">
                  {/* Booking Step */}
                  <ul className="step-register row">
                    <li className="active col-md-3">
                      <div className="multi-step-icon">
                        <ImageWithBasePath src="assets/img/icons/calendar-icon.svg" alt="img" />
                      </div>
                      <div className="multi-step-info">
                        <h6 style={{ color: '#fff' }}>Appointment</h6>
                        <p style={{ color: '#fff' }}>Choose time &amp; date for the service</p>
                      </div>
                    </li>
                    <li className="col-md-3">
                      <div className="multi-step-icon">
                        <span>
                          <ImageWithBasePath src="assets/img/icons/choose-icon-3.svg" alt="img" />
                        </span>
                      </div>
                      <div className="multi-step-info">
                        <h6 style={{ color: '#fff' }}>Waiting For Technicion</h6>
                        <p style={{ color: '#fff' }}>Accpect the technicion for service</p>
                      </div>
                    </li>
                    <li className="col-md-3">
                      <div className="multi-step-icon">
                        <ImageWithBasePath src="assets/img/icons/wallet-icon.svg" alt="img" />
                      </div>
                      <div className="multi-step-info">
                        <h6 style={{ color: '#fff' }}>Payment</h6>
                        <p style={{ color: '#fff' }}>Select Payment Gateway</p>
                      </div>
                    </li>
                    <li className="col-md-3">
                      <div className="multi-step-icon">
                        <ImageWithBasePath src="assets/img/icons/book-done.svg" alt="img" />
                      </div>
                      <div className="multi-step-info">
                        <h6 style={{ color: '#fff' }}>Done </h6>
                        <p style={{ color: '#fff' }}>Completion of Booking</p>
                      </div>
                    </li>
                  </ul>
                  {/* /Booking Step */}
                  {/* Appointment */}
                  <div className="booking-service card shadow-none"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    borderRadius: "15px",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    borderColor: "#ffffff00",
                    color: "#fff",
                  }}>
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-lg-5">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 service-img me-3">
                              <img
                                // src="assets/img/services/service-27.jpg"
                                src={
                                  category.category_view_icon ||
                                  "placeholder-image-path.jpg"
                                }
                                alt="img"
                              />
                            </div>
                            <div className="serv-profile">
                              <span className="badge badge-soft-primary">
                                {/* Car Wash */}
                                {category.main_type}
                              </span>
                              <h4 className="my-2" style={{ color: '#fff' }}> {category.title}</h4>

                              {/* Tech Profile */}
                              {/* <div className="d-flex align-items-center">
                                <span className="avatar avatar-md rounded-circle me-2">
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-01.jpg"
                                    className="rounded-circle"
                                    alt="img"
                                  />
                                </span>
                                <div className="serv-pro-info">
                                  <h6 className="fs-14 fw-medium">Raskhan Mohamed</h6>
                                  <p className="serv-review">
                                    <i className="fa-solid fa-star" />{" "}
                                    <span>4.9 </span>(255 reviews)
                                  </p>
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-5">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="">
                                <div className="provide-box d-flex align-items-center mb-3">
                                  <span className="me-2">
                                    <i className="feather icon-phone" style={{ color: '#000' }} />
                                  </span>
                                  <div className="provide-info">
                                    <h6 className="fs-14 fw-medium mb-1" style={{ color: '#fff' }}>
                                      Phone
                                    </h6>
                                    <p>+94 76 24 25 678</p>
                                  </div>
                                </div>
                                <div className="provide-box d-flex align-items-center">
                                  <span className="me-2">
                                    <i className="feather icon-mail" style={{ color: '#000' }} />
                                  </span>
                                  <div className="provide-info">
                                    <h6 className="fs-14 fw-medium mb-1" style={{ color: '#fff' }}>
                                      Email
                                    </h6>
                                    <p>mahincha@gmail.com</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="">
                                <div className="provide-box d-flex align-items-center mb-3">
                                  <span className="me-2">
                                    <i className="feather icon-map-pin" style={{ color: '#000' }} />
                                  </span>
                                  <div className="provide-info">
                                    <h6 className="fs-14 fw-medium mb-1" style={{ color: '#fff' }}>
                                      Address
                                    </h6>
                                    <p>Kandy , Sri lanka </p>
                                  </div>
                                </div>
                                <div className="provide-box d-flex align-items-center">
                                  <span className="me-2">
                                    <i className="ti ti-wallet" style={{ color: '#000' }} />
                                  </span>
                                  <div className="provide-info">
                                    <h6 className="fs-14 fw-medium mb-1" style={{ color: '#fff' }}>
                                      Service Amount
                                    </h6>
                                    <h5 style={{ color: '#fff' }}>₹ {category.price} </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="d-flex align-items-center social">
                            <Link
                              to="#"
                              className="d-flex align-items-center justify-content-center"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* tttttttttttt */}
                  <div className="booking-service card shadow-none"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    borderRadius: "15px",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    borderColor: "#ffffff00",
                    color: "#fff",
                  }}>
                    <div className="card-body">
                      <div className="row align-items-center">
                        {/* Column 1 */}

                        <div className="#">
                          {category.fields.map(
                            (
                              field: {
                                lbl: string;
                                isRequired: boolean;
                                type: string;
                                maxlength?: number;
                                minlength?: number;
                                options?: number[];
                              },
                              index: number
                            ) => (
                              <div
                                key={index}
                                className="d-flex align-items-center justify-content-between mb-3 border border-gray-300 p-2 rounded"
                              >
                                <h6 className="fs-16 fw-medium mb-0" style={{ color: '#fff' }}>
                                  {field.lbl}
                                </h6>
                                <p>
                                  {field.type === "counter" ? (
                                    <div className="flex items-center gap-4">
                                      <Button
                                        onClick={() =>
                                          setCount((prev) => prev - 1)
                                        }
                                        variant="destructive"
                                      >
                                        -
                                      </Button>
                                      &nbsp;&nbsp;
                                      <span className="text-lg font-semibold w-10 text-center">
                                        {count}
                                      </span>
                                      &nbsp;&nbsp;
                                      <Button
                                        onClick={() =>
                                          setCount((prev) => prev + 1)
                                        }
                                        variant="default"
                                      >
                                        +
                                      </Button>
                                    </div>
                                  ) : field.type === "select" ? (
                                    <select
                                      // onChange={(e) => setCount(Number(e.target.value))}
                                      className="border p-2 rounded"
                                      value={count}
                                    >
                                      {field.options?.map(
                                        (option: number, idx: number) => (
                                          <option key={idx} value={option}>
                                            {option}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  ) : field.type === "pickColor" ? (
                                    <input
                                      type="color"
                                      value={selectedColor}
                                      // onChange={(e) => setSelectedColor(e.target.value)}
                                      className="w-16 h-8 border rounded"
                                    />
                                  ) : field.type === "input" ? (
                                    <input
                                      type="text"
                                      placeholder="Enter text"
                                      className="border p-2 rounded w-full"
                                      maxLength={field.maxlength}
                                      minLength={field.minlength}
                                    />
                                  ) : (
                                    <input
                                      type="checkbox"
                                      className="w-5 h-5 accent-blue-500 cursor-pointer"
                                      // checked={field.isRequired}
                                      // onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                                    />
                                  )}
                                </p>
                              </div>
                            )
                          )}

                          {/* Promo Code-------------------- */}
                          <div className="booking-coupon">
                            <div className="form-group w-100">
                              <div className="coupon-icon">
                                <select
                                  className="form-control"
                                  value={selectedOffer}
                                  onChange={(e) =>
                                    setSelectedOffer(e.target.value)
                                  } // Update the selected offer
                                >
                                  <option value="" disabled>
                                    Promo Code
                                  </option>
                                  {offers.map((offer, index) => (
                                    <option key={index} value={offer.id}>
                                      {" "}
                                      {/* Assuming `id` is the unique identifier */}
                                      {offer.title} ,{/* {offer.discount}%   */}
                                      {/* Display the title or another field */}
                                    </option>
                                  ))}
                                </select>
                                {/* <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Promo Code"
                                /> */}
                                <span>
                                  <ImageWithBasePath
                                    src="assets/img/icons/coupon-icon.svg"
                                    alt="image"
                                  />
                                </span>
                              </div>
                            </div>
                            <div className="form-group">
                              <button
                                className="btn btn-dark"
                                onClick={applyPromoCode}
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                          <div className="save-offer">
                            {/* <p>
                              <i className="fa-solid fa-circle-check" /> Your total saving
                              on this order $5.00
                            </p> */}
                            {appliedPromoId && (
                              <div className="save-offer">
                                <p>
                                  <i className="fa-solid fa-circle-check" />{" "}
                                  Applied Promo Code: {appliedPromoId}
                                </p>
                              </div>
                            )}
                          </div>

                          <div className="booking-coupon">
                            <div className="form-group w-100">
                              <h6 className="fs-16 fw-medium mb-0" style={{ color: '#fff' }}>
                                Working Hours
                              </h6>
                            </div>
                            <div className="form-group">
                              {/* Dropdown for selecting working hours */}
                              <select
                                className="form-control"
                                value={selectedHours} // Bind the selected value from state
                                onChange={handleChange} // Update state on change
                              >
                                {timeOptions.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  {/* /Appointment */}

                  {/* Appointment Date & Time */}
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="book-title">
                        <h5 style={{ color: '#fff' }}>Appointment Date</h5>
                      </div>
                      <div className="card">
                        <div className="card-body p-2 pt-3">
                          <div id="datetimepickershow">
                            <Calendar
                              className="w-100 border-0"
                              onChange={() => onChange}
                              value={value}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Appointment Time */}
                    <div className="col-lg-8">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="book-title">
                            <h5 style={{ color: '#fff' }}>Appointment Time</h5>
                          </div>
                        </div>
                      </div>

                      <div className="token-slot mt-2">
                        {timeSlots.map((time, index) => (
                          <div
                            key={index}
                            className="form-check-inline visits me-0"
                          >
                            <label className="visit-btns">
                              <input
                                type="radio"
                                className="form-check-input"
                                name="appointment"
                                value={time}
                                checked={selectedTime === time}
                                onChange={() => setSelectedTime(time)}
                              />
                              <span className="visit-rsn">{time}</span>
                            </label>
                          </div>
                        ))}
                      </div>

                      <div className="d-flex align-items-center justify-content-end mt-4">
                        <Link to="#" className="btn btn-light me-2">
                          Cancel
                        </Link>
                        <Button
                          // onClick={handleBookAppointment}
                          onClick={saveAppointment}
                          className="btn btn-dark"
                        >
                          Book Appointment
                        </Button>
                      </div>
                    </div>
                  </div>
                  {/* /Appointment Date & Time */}
                </div>
                {/* /Booking */}
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    </>
  );
};

export default Booking1;
